import React, { useState } from 'react';

const CostBreakdown = ({ offerPrice = 2720000 }) => {
  const [price, setPrice] = useState(offerPrice);
  const stampDuty = Math.round(price * 0.055);
  const legalFees = 2500;
  const buildingInspection = 800;
  const pestInspection = 400;
  const conveyancing = 1800;
  const total = price + stampDuty + legalFees + buildingInspection + pestInspection + conveyancing;
  const fmt = (n) => `$${n?.toLocaleString('en-AU')}`;
  const items = [
    { label: 'Offer Price', value: fmt(price), bold: true, color: '#00D4FF' },
    { label: 'Stamp Duty (est. 5.5%)', value: fmt(stampDuty), color: '#FFAA00' },
    { label: 'Legal Fees', value: fmt(legalFees), color: '#888' },
    { label: 'Building Inspection', value: fmt(buildingInspection), color: '#888' },
    { label: 'Pest Inspection', value: fmt(pestInspection), color: '#888' },
    { label: 'Conveyancing', value: fmt(conveyancing), color: '#888' },
  ];

  return (
    <div className="bg-card rounded-xl border border-border p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Total Cost Breakdown</h3>
      <div className="mb-4">
        <label className="text-sm text-muted-foreground mb-1 block">Adjust Offer Price</label>
        <input type="range" min={2400000} max={3200000} step={10000} value={price} onChange={e => setPrice(Number(e?.target?.value))} className="w-full h-2 rounded-full appearance-none cursor-pointer" style={{ accentColor: '#00D4FF' }} />
        <div className="flex justify-between text-xs text-muted-foreground mt-1">
          <span>$2.4M</span>
          <span className="font-semibold text-foreground">${(price / 1000000)?.toFixed(2)}M</span>
          <span>$3.2M</span>
        </div>
      </div>
      <div className="space-y-2 mb-4">
        {items?.map((item, i) => (
          <div key={i} className="flex justify-between items-center py-2 border-b border-border/50 last:border-0">
            <span className="text-sm text-muted-foreground">{item?.label}</span>
            <span className={`text-sm font-medium ${item?.bold ? 'text-base font-bold' : ''}`} style={{ color: item?.color }}>{item?.value}</span>
          </div>
        ))}
      </div>
      <div className="p-3 rounded-lg flex justify-between items-center" style={{ background: 'rgba(0,212,255,0.1)', border: '1px solid rgba(0,212,255,0.2)' }}>
        <span className="font-semibold text-foreground">Total Cost to Buy</span>
        <span className="text-xl font-bold" style={{ color: '#00D4FF' }}>{fmt(total)}</span>
      </div>
    </div>
  );
};

export default CostBreakdown;
